/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';

import { Container, makeStyles, Typography } from '@material-ui/core';

import IconClose from '../../assets/images/ic-close-round.svg';
import IconDcm from '../../assets/images/ic-dcm.svg';
import IconDoc from '../../assets/images/ic-doc.svg';
import { ReactComponent as IconDownload } from '../../assets/images/ic-download.svg';
import IconPicture from '../../assets/images/ic-picture.svg';
import IconVideo from '../../assets/images/ic-video.svg';
import { DCM, DOCS, IMAGE, VIDEO, THREE, DOCX } from '../../models/Resource';
import { downloadFile } from '../../utils/files.js';

const useStyles = makeStyles((theme) => {
  return {
    additionalContainerEmpty: {
      alignItems: 'center',
      backgroundColor: '#F5F5F5',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      marginTop: '8px',
      minHeight: '90px',
      padding: '16px',
    },
    additionalFileContainer: {
      alignItems: 'center',
      backgroundColor: '#F5F5F5',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '8px',
      padding: '8px 12px',
    },
    additionalFileName: {
      color: '#172B4D',
      fontSize: '12px',
      lineHeight: '16px',
      maxWidth: '150px',
      wordBreak: 'break-all',
    },
    additionalFileTitleContainer: {
      alignItems: 'center',
      display: 'flex',
    },
    additionalFilesContainer: {
      marginTop: '28px',
    },
    additionalFilesListContainer: {
      maxHeight: '400px',
      overflowY: 'auto',
    },
    additionalIconImage: {
      height: '100%',
      marginRight: '12px',
      width: '20px',
    },
    additionalIconInteraction: {
      height: '16px',
      marginRight: '8px',
      width: '16px',
    },
    additionalIconInteractionDownload: {
      fill: theme.palette.primary.main,
      stroke: theme.palette.primary.main,
    },
    additionalInteractionText: {
      color: theme.palette.primary.main,
      fontSize: '12px',
      lineHeight: '16px',
      marginBottom: '0px',
    },
    additionalNoFilesFound: {
      marginBottom: '8px',
    },
    additionalSubtitle: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '16px',
      marginTop: '8px',
    },
    container: {
      display: 'block',
      margin: '0px',
      padding: '20px',
      position: 'relative',
      width: '600px',
    },
    downloadText: {
      display: 'flex',
      gap: '4px',
    },
    iconClose: {
      cursor: 'pointer',
      height: '24px',
      position: 'absolute',
      right: '16px',
      top: '16px',
      width: '24px',
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      marginBottom: '0px',
      textAlign: 'left',
    },
  };
});

const iconSetup = {
  [DCM]: IconDcm,
  [DOCS]: IconDoc,
  [IMAGE]: IconPicture,
  [VIDEO]: IconVideo,
};

const shouldViewType = [DCM, DOCS, VIDEO, THREE, IMAGE];

export default ({ onCrossIconClick, files, onViewFile, showDownloadButton }) => {
  const classes = useStyles();

  const handleClose = () => {
    if (onCrossIconClick) onCrossIconClick();
  };

  const handleViewFile = useCallback(
    (file) => {
      if (onViewFile) onViewFile(file);
    },
    [onViewFile]
  );

  const renderAdditionalFiles = useCallback(() => {
    const additionalFiles = files || [];

    let mainContent = '';
    if (!additionalFiles?.length) {
      mainContent = (
        <div className={classes.additionalContainerEmpty}>
          <div>
            <Typography className={[classes.additionalSubtitle, classes.additionalNoFilesFound].join(' ')}>No additional files found</Typography>
          </div>
        </div>
      );
    } else {
      const listFiles = additionalFiles.map((file) => {
        const { fileName = '', type, description, uuid } = file;
        const fileTitle = fileName || description || '';

        const cleanFileName = fileTitle.startsWith('0-') ? fileTitle.slice(2, fileTitle.length) : fileTitle;
        const selectedIcon = iconSetup[type] || IconDoc;
        const shouldView = shouldViewType.includes(type);
        const isDocxFile = file.originalType === DOCX;

        const actionButton =
          shouldView && !isDocxFile ? (
            <div className={classes.downloadText}>
              {showDownloadButton && [DOCS, IMAGE].includes(file.type) && (
                <a
                  onClick={() => downloadFile(file)}
                  style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px', textDecoration: 'none' }}>
                  <IconDownload className={`${classes.additionalIconInteraction} ${classes.additionalIconInteractionDownload}`} />
                  <Typography className={classes.additionalInteractionText}>Download</Typography>
                </a>
              )}
              <div onClick={() => handleViewFile(file)} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px' }}>
                <Typography className={classes.additionalInteractionText}>View</Typography>
              </div>
            </div>
          ) : (
            <a
              onClick={() => downloadFile(file)}
              style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', justifyContent: 'center', marginRight: '8px', textDecoration: 'none' }}>
              <IconDownload className={`${classes.additionalIconInteraction} ${classes.additionalIconInteractionDownload}`} />
              <Typography className={classes.additionalInteractionText}>Download</Typography>
            </a>
          );

        return (
          <div key={uuid} className={classes.additionalFileContainer}>
            {/* Icon Title */}
            <div className={classes.additionalFileTitleContainer}>
              <img src={selectedIcon} className={classes.additionalIconImage} alt="" />
              <Typography className={classes.additionalFileName}>{cleanFileName}</Typography>
            </div>

            {/* Button */}
            {actionButton}
          </div>
        );
      });

      mainContent = <div className={classes.additionalFilesListContainer}>{listFiles}</div>;
    }

    return (
      <div className={classes.additionalFilesContainer}>
        <Typography className={classes.additionalSubtitle}>Additional radiology scans and reports</Typography>

        {mainContent}
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classes, files, handleViewFile]);

  return (
    <Container disableGutters className={classes.container}>
      <img onClick={handleClose} src={IconClose} className={classes.iconClose} alt="Close Icon" />

      <Typography className={classes.typographyTitle}>List Additional Files</Typography>

      {renderAdditionalFiles()}
    </Container>
  );
};
